import React, { useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router';
import io from 'socket.io-client';
import styled from 'styled-components';

import Metro from './v2/components/Header';
import Home from './v2/pages/HomePage';
// LMS 페이지 (강사/과정/수강신청/내강의실/일정)
import Instructors from './v2/pages/InstructorsPage';
import Courses from './v2/pages/CoursesPage';
import CourseStudio from './v2/pages/CourseStudioPage';
import Enroll from './v2/pages/EnrollPage';
import MyClassroom from './v2/pages/MyClassroomPage';
import DailyLectureAdmin from './v2/pages/DailyLectureAdminPage';
import Schedule from './v2/pages/SchedulePage';
import Help from './v2/pages/HelpPage';
import BoardPage from './v2/pages/BoardPage';
import WorkRoom from './v2/pages/WorkRoomPage';
import Portfolio from './v2/pages/PortfolioWorkspacePage';
import WorkCalendar from './v2/pages/WorkCalendarPage';
import Developer from './v2/pages/DeveloperWorkspacePage';
import Login from './v2/pages/LoginPage';
import MemberJoin from './v2/pages/JoinPage';
import MyPage from './v2/pages/MyPagePage';
import DownloadPage from './v2/pages/DownloadPage';

import Join from './Common/Component/ChatRoom/Join/Join';
import Chat from './Common/Component/ChatRoom/Chat/Chat';
import FindMemberInfo from './Common/Component/LoginBox/FindMemberInfo';
import MyInfoUpdate from './Common/Component/LoginBox/MyInfoUpdate';
import Remote from './Common/Component/RemotePage';
import Uploader from './Screen/Uploader';
import VideoChat from './Common/Component/VideoChat';
import HealthCheck from './Screen/HealthCheck';
import Messages from './Common/Component/ChatRoom/Messages/Messages';
import InfoBar from './Common/Component/ChatRoom/InfoBar/InfoBar';
import Input from './Common/Component/ChatRoom/Input/Input';


import './Common/Component/ChatRoom/Chat/Chat.css';
import './styles/brand.css';
import { AppWrapper, HeaderWrapper, MainContent, FooterWrapper } from './components/templates/PageLayout/PageLayout.styled';
import { ThemeProvider } from './styles/theme';

// Socket.IO 연결을 모듈 레벨로 이동 (매 렌더링마다 새 연결 방지)
const socket = io('https://edu.antsnest.co.kr');

function App() {
  return (
    <ThemeProvider>
      <AppWrapper>
      <HeaderWrapper>
        <Metro />
      </HeaderWrapper>
      <MainContent>
        <Route path="/" exact component={Home} key="Home" />
        <Route path="/Uploader" exact component={Uploader} key="Uploader" />

        {/* LMS 핵심 메뉴 */}
        <Route path="/Instructors" exact component={Instructors} key="Instructors" />
        <Route path="/Courses" exact component={Courses} key="Courses" />
        <Route path="/CourseStudio" exact component={CourseStudio} key="CourseStudioNew" />
        <Route path="/CourseStudio/:id" exact component={CourseStudio} key="CourseStudioEdit" />
        <Route path="/Enroll" exact component={Enroll} key="Enroll" />
        <Route path="/MyClassroom" exact component={MyClassroom} key="MyClassroom" />
        <Route path="/Admin/DailyLectures" exact component={DailyLectureAdmin} key="DailyLectureAdmin" />
        <Route path="/Schedule" exact component={Schedule} key="Schedule" />

        <Route path="/Help" exact component={Help} key="Help" />
        <Route path="/WorkRoom" exact component={WorkRoom} key="WorkRoom" />
        <Route path="/Portfolio" exact component={Portfolio} key="Portfolio" />
        <Route path="/WorkCalendar" exact component={WorkCalendar} key="WorkCalendar" />
        <Route path="/Developer" exact component={Developer} key="Developer" />
        <Route path="/NewsBoard/:num" render={(props) => (<BoardPage {...props} Type="NewsBoard" />)} />
        <Route path="/FreeBoard/:num" render={(props) => (<BoardPage {...props} Type="FreeBoard" />)} />
        <Route path="/DeveloperNoteBoard/:num" render={(props) => (<BoardPage {...props} Type="DeveloperNoteBoard" />)} />
        <Route path="/QaBoard/:num" render={(props) => (<BoardPage {...props} Type="QaBoard" />)} />
        <Route path="/Download" exact render={() => <DownloadPage type="windows" />} key="Download" />
        <Route path="/DownloadMobile" exact render={() => <DownloadPage type="mobile" />} key="DownloadMobile" />

        {/* 인증/마이페이지 (SSO) */}
        <Route path="/Login" exact component={Login} key="Login" />
        <Route path="/MemberJoin" exact component={MemberJoin} key="MemberJoin" />
        <Route path="/MyInfoUpdate" exact component={MyInfoUpdate} key="MyInfoUpdate" />
        <Route path="/FindMemberInfo" exact component={FindMemberInfo} key="FindMemberInfo" />
        <Route path="/MyPage" exact component={MyPage} key="MyPage" />

        {/* 실시간 채팅/통화 (헬스체크/리모트 포함) */}
        <Route path="/join" exact component={Join} key="Join" />
        <Route path="/chat" exact component={Chat} key="Chat" />
        <Route path="/HealthCheck" exact component={HealthCheck} key="HealthCheck" />
        <Route path="/Remote" exact component={Remote} key="Remote" />
        <Route path="/room/:roomId" exact component={VideoChat} key="room" />
          <MiniChatRoom socket={socket}/>
      </MainContent>
      <FooterWrapper>
        <div className="footer-content">
          <strong className="footer-company">ANTSNEST DEVELOPER CENTER</strong>
          <div className="footer-info">
            <span>대표: 윤수진</span>
            <span className="footer-divider">|</span>
            <span>사업자등록번호: 626-34-00904</span>
          </div>
          <div className="footer-info">
            <span>주소: (06253) 서울특별시 강남구 도곡로3길 13 (론-메이에트 타워) 206-1호</span>
          </div>
          <div className="footer-info">
            <span>전화: 070-9979-0814</span>
            <span className="footer-divider">|</span>
            <span>이메일: admin@antsnest.co.kr</span>
          </div>
          <p className="footer-copyright">© ANTSNEST DEVELOPER CENTER Co. Ltd. All Rights Reserved.</p>
        </div>
      </FooterWrapper>
    </AppWrapper>
    </ThemeProvider>
  );
}

export default App;

const MiniChatWrapper = styled.div`
  position: fixed;
  bottom: 55px;
  right: 30px;
  width: 300px;
  z-index: 50;
`;

const MiniChatSection = styled.section`
  overflow: hidden;
  position: relative;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  background: ${({ theme }) => theme.colors.neutral[0]};
  height: ${({ $expanded }) => $expanded ? '350px' : '50px'};
  box-shadow: ${({ theme }) => theme.elevation.md};
  transition: height ${({ theme }) => theme.transition.slow};
`;

const MiniChatHeader = styled.header`
  display: flex;
  width: 80%;
  height: 15%;
  justify-content: space-between;
  align-items: center;
`;

const MiniChatToggle = styled.div`
  width: 25px;
  height: 25px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background: ${({ theme }) => theme.colors.neutral[0]};
  border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
  cursor: pointer;
`;

const MiniChatBody = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.neutral[100]};
  border: 1px solid ${({ theme }) => theme.colors.neutral[200]};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
`;

function MiniChatRoom({socket}) {
  
  const [expanded, setExpanded] = useState(false);
  const [name, setName] = useState('익명');
  const [room, setRoom] = useState('antsnest');
  const [users, setUsers] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [flag, setFlag] = useState(0);
  const ENDPOINT = 'https://edu.antsnest.co.kr';

  // 로그인 세션에서 사용자명 가져오기
  useEffect(() => {
    fetch('/auth/check-session')
      .then(res => res.json())
      .then(data => {
        if (data && data.user && data.user.name) {
          setName(data.user.name);
        } else if (data && data.name) {
          setName(data.name);
        }
      })
      .catch(() => {
        // 비로그인 시 "익명" 유지
      });
  }, []);

  useEffect(() => {
    if (name === '익명' && !socket.connected) return;
    
    socket.on('connect', () => {
      // 소켓이 서버에 연결된 후에 실행됩니다.
      socket.emit('join', { id: socket.id, name, room }, (error) => {
        if (error) {
          setFlag(1);
          alert(error);
        }
      });
    });
    
    socket.on('message', message => {
      setMessages(messages => [...messages, message]);
    });

    socket.on("roomData", ({ users }) => {
      setUsers(users);
    });

    // 이미 연결된 상태라면 바로 join
    if (socket.connected) {
      socket.emit('join', { id: socket.id, name, room }, (error) => {
        if (error) {
          setFlag(1);
          alert(error);
        }
      });
    }
   
    return () => {
      socket.off('connect');
      socket.off('message');
      socket.off('roomData');
    };
  }, [name]);

  const sendMessage = (event) => {
    event.preventDefault();
    if (message) {
      socket.emit('sendMessage', { id: socket.id, message }, () => setMessage(''));
    }
  }

  if (flag) {
    return (
      <Redirect to="/" />
    )
  }

  
  
  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <MiniChatWrapper>
      <MiniChatSection $expanded={expanded}>
        <MiniChatHeader>
          <label>채팅방</label>
          <MiniChatToggle onClick={toggleExpand} />
        </MiniChatHeader>

        {expanded && (
        <MiniChatBody>
          <div className="outerContainer">
            <div className="ContainerBox">
              <div className="container">
                <InfoBar room={room} />
                <Messages messages={messages} name={name} />
                <Input message={message} setMessage={setMessage} sendMessage={sendMessage} />
              </div>
            </div>
          </div>
        </MiniChatBody>)}
      </MiniChatSection>
    </MiniChatWrapper>
  );
}
